export function getBaseUrl(specifiedVersion = null) {
    const baseDomain = process.env.VUE_APP_API || "https://customercareapidev.fgt.llc";
    const version = specifiedVersion ?? "v1";
    return `${baseDomain}/api/${version}`;
}